import React from "react";

const ToggleSwitch = ({ checked, onChange, label, disabled = false }) => (
  <label
    className={`flex items-center gap-2 select-none ${
      disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
    }`}
  >
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onChange(!checked);
      }}
      className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-theme-primary focus:ring-offset-2 focus:ring-offset-theme-main ${
        checked ? "bg-theme-primary" : "bg-theme-main"
      } ${disabled ? "pointer-events-none" : ""}`}
    >
      <span
        className={`inline-block h-3.5 w-3.5 rounded-full bg-white shadow-sm transition-transform ${
          checked ? "translate-x-5" : "translate-x-1"
        }`}
      />
    </button>
    <span className="text-sm text-theme-text opacity-80">{label}</span>
  </label>
);

export default ToggleSwitch;
